import twitter from "../assets/icons/twitter.png";
import tele from "../assets/icons/tele.png";

export default function FooterComponent() {
  return (
    <div className="bg-[#141414]">
      <div className="py-6 px-4 mx-auto flex flex-col sm:flex-row items-center justify-center sm:justify-between max-w-7xl gap-4">
        <p className="text-sm text-white funnel-display-regular text-center sm:text-left">
          Copyright © 2025 AxE Protocol. All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <img src={twitter} alt="twitter" className="w-5 h-5" />
          <img src={tele} alt="tele" className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
}
